import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        forms: '<',
        isDisabled: '<',
        feedbackForms: '=',
        trainingForm: '=',
        key: '<'
    },
    template: `
        <form-row error="vm.form.errors.courseTrainings[vm.key].isHintingAllowed">
            <label class="label">{{ 'courses.Allow hinting' | translate }}</label>
            <div class="items">
                <ul class="checkboxes">
                    <li>
                        <label>
                            <input ng-disabled="vm.isDisabled" type="checkbox" ng-model="vm.trainingForm.isHintingAllowed">
                            {{ 'general.Yes' | translate }}
                        </label>
                    </li>
                </ul>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseTrainings[vm.key].feedbackFormId">
            <label class="label">{{ 'courses.Associated feedback form' | translate }}</label>
            <div class="items">
                <select ng-disabled="vm.isDisabled" class="form-control"
                    ng-model="vm.trainingForm.feedbackFormId"
                    ng-options="form.id as form.activeI18n.name for form in vm.feedbackForms" required>
                </select>
                <form-row-error></form-row-error>
                <p class="desc warn" ng-if="!vm.hasAccessToFeedbackForm(vm.trainingForm.feedbackFormId)">
                    {{ 'courses.Saved value is not displayed. You do not have access to the attached form' | translate }}
                </p>
            </div>
        </form-row>
    `
})

export default class {
    constructor (lodash, $translate) {
        this.lodash = lodash;
        this.$translate = $translate;
    }

    hasAccessToFeedbackForm (formId) {
        if (!formId) {
            return true;
        }
        return !!this.lodash.find(this.feedbackForms, (form) => parseInt(form.id, 10) === parseInt(formId, 10));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/additional/test/index.js